import React, { useEffect, useState } from "react";
import Dropdown from "../input/Dropdown";
import { FORMS, MODULES } from "../../const";
import Button from "../input/Button";
import { useSelector } from "react-redux";
import { bulkUpdateStatusChange } from "../../api/employeeApi";
import { toast, ToastContainer } from "react-toastify";
import { getBulkDropdownData } from "../../api/keyvalue";
import Input from "../input/Input";

const EmployeeStatusChange = ({ empIds, closeModal, onUpdateSuccess }) => {
  const [employeeData, setEmployeeData] = useState({
    empActive: "",
    empStatus: "",
    empRemark: "",
  });
  const [activeOptions, setActiveOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  console.log("selected ids", empIds);

  const FORM = FORMS.EMPLOYEE.EMP_DETAIL.form;
  const user = useSelector((state) => state.user);

  useEffect(() => {
    (async () => {
      const { active = [], vehicle_status: statusOpts } = await getBulkDropdownData([
        { key: "active" },
        { key: "vehicle_status" },
        
      ]);
      setActiveOptions(active);
      setStatusOptions(statusOpts);
    })();
  }, []);

  const bulkUpdateStatus = async () => {
    if (!employeeData.empActive || !employeeData.empStatus) {
      toast.error("Please select Active and Status values!", {
        autoClose: 5000,
        containerId: "Modal",
      });
      return;
    }
    try {
      const bulkUpdateStatusChangeRequest = {
        empIds: empIds,
        empActive: employeeData.empActive,
        empStatus: employeeData.empStatus,
        empRemark: employeeData.empRemark,
        author: user?.username,
      };
      console.log("bulk update status", bulkUpdateStatusChangeRequest);
      const response = await bulkUpdateStatusChange(
        bulkUpdateStatusChangeRequest,
      );

      toast.success("Employee Status Changed Successfully", {
        autoClose: 1000,
        containerId: "Modal",
      });
      setEmployeeData({
        empActive: "",
        empStatus: "",
      });
      setTimeout(() => {
        closeModal();
      }, 2000);
    } catch (e) {
      console.error(e);
      toast.error("Failed to update status.", {
        autoClose: 5000,
        containerId: "Modal",
      });
    }
  };

  return (
    <div>
      <form className="ui form">
        <div className="ui segment">
          <h4 className="ui dividing headder">Change Status</h4>
          <div className="ui segment">
            <div className="two fields">
              <Dropdown
                required={true}
                label="Active"
                module={MODULES.Master}
                field="emp_active"
                placeholder="Active"
                style={{ height: "20px" }}
                options={activeOptions}
                form={FORM}
                value={employeeData.empActive}
                onChange={(e, data) => {
                  setEmployeeData((prevState) => ({
                    ...prevState,
                    empActive: data.value,
                  }));
                }}
              />
              <Dropdown
                label="Status"
                required={true}
                module={MODULES.Master}
                form={FORM}
                field="emp_status"
                placeholder="Status"
                options={statusOptions}
                value={employeeData.empStatus}
                style={{ height: "20px" }}
                onChange={(e, data) => {
                  setEmployeeData((prevState) => ({
                    ...prevState,
                    empStatus: data.value,
                  }));
                }}
              />
            </div>
            <div>
              <Input
                label="Remarks"
                field="emp_remarks"
                placeholder="Remarks"
                value={employeeData.empRemark}
                onChange={(e, data) => {
                  setEmployeeData((prevState) => ({
                    ...prevState,
                    empRemark: e.target.value,
                  }));
                }}
              />
            </div>
            
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <Button
                label="Update"
                authenticated={true}
                form={FORMS.EMPLOYEE.EMP_STATUS.form}
                module={MODULES.Master}
                onClick={bulkUpdateStatus}
              />
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default EmployeeStatusChange;
